// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { CatalogFeed } from './catalog-feed';
import { DocSubmitType } from './doc-submit-type';
import { ManufacturerCryptonym } from './manufacturer-cryptonym';
import { ManufacturerFeatureKindMap } from './manufacturer-feature-kind-map';
import { ManufacturerFeedStatus } from './manufacturer-feed-status';
import { ManufacturerImage } from './manufacturer-image';
import { PoCancelRequestQueue } from './po-cancel-request-queue';
import { PoHeader } from './po-header';
import { ProductType } from './product-type';
import { StagedFeedRun } from './staged-feed-run';
import { StagedProductType } from './staged-product-type';
import { ActiveStatusEnum } from './enums';
import { DocSubmitTypeEnum } from './enums';
import { ManufacturerFeedStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Manufacturer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(50) */
  accountReferenceName?: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(50) */
  billingAddress1?: string;
  /** String(50) */
  billingAddress2?: string;
  /** String(50) */
  billingCity?: string;
  /** String(50) */
  billingContact?: string;
  /** String(50) */
  billingEmail?: string;
  /** String(4) */
  billingExt?: string;
  /** String(25) */
  billingFax?: string;
  /** String(50) */
  billingName?: string;
  /** String(10) */
  billingState?: string;
  /** String(25) */
  billingTelephone?: string;
  /** String(10) */
  billingZipCode?: string;
  /** Int32 FK catalogFeed */
  catalogFeedId?: number;
  /** String(50) */
  catalogFeedKey?: string;
  /** String(512) */
  description?: string;
  /** DateTime */
  lastBackorderRequestDate?: Date;
  /** Int32 */
  leadTimeDays!: number;
  /** Enum FK manufacturerFeedStatus */
  manufacturerFeedStatusId!: ManufacturerFeedStatusEnum;
  /** String(60) */
  name!: string;
  /** String(6) */
  oLD_MFT_KEY?: string;
  /** Enum FK poDocSubmitType */
  poDocSubmitTypeId!: DocSubmitTypeEnum;
  /** Binary */
  rowVersion!: any;
  /** Int32 */
  transitTimeDays!: number;
  /** String(50) */
  whAddress1?: string;
  /** String(50) */
  whAddress2?: string;
  /** String(50) */
  whCity?: string;
  /** String(50) */
  whContact?: string;
  /** String(50) */
  whEmail?: string;
  /** String(4) */
  whExt?: string;
  /** String(25) */
  whFax?: string;
  /** String(50) */
  whName?: string;
  /** String(10) */
  whState?: string;
  /** String(25) */
  whTelephone?: string;
  /** String(10) */
  whZipCode?: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK catalogFeedId */
  catalogFeed!: CatalogFeed;
  /** Inv FK manufacturerId */
  manufacturerCryptonym!: ManufacturerCryptonym;
  /** Inv FK manufacturerId */
  manufacturerFeatureKindMaps!: ManufacturerFeatureKindMap[];
  /** FK manufacturerFeedStatusId */
  manufacturerFeedStatus!: ManufacturerFeedStatus;
  /** Inv FK manufacturerId */
  manufacturerImages!: ManufacturerImage[];
  /** Inv FK manufacturerId */
  poCancelRequestQueues!: PoCancelRequestQueue[];
  /** FK poDocSubmitTypeId */
  poDocSubmitType!: DocSubmitType;
  /** Inv FK manufacturerId */
  poHeaders!: PoHeader[];
  /** Inv FK manufacturerId */
  productTypes!: ProductType[];
  /** Inv FK manufacturerId */
  stagedFeedRuns!: StagedFeedRun[];
  /** Inv FK manufacturerId */
  stagedProductTypes!: StagedProductType[];
}

